import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { SliderHandle as SliderHandle$1 } from '@reach/slider';
import 'react';
import '../hooks/useDetectInputMethod.js';
import '@reach/auto-id';
import { useTheme } from '../hooks/useTheme.js';
import { useSliderContext } from './SliderContext.js';

var SliderHandle = function (props) {
    var children = props.children, label = props.label, labelledBy = props.labelledBy; props.sx; var renderHandleLabel = props.renderHandleLabel, value = props.value, forwardProps = __rest(props, ["children", "label", "labelledBy", "sx", "renderHandleLabel", "value"]);
    var valueLabel = (renderHandleLabel === null || renderHandleLabel === void 0 ? void 0 : renderHandleLabel(value)) || "".concat(value);
    var displayValue = useSliderContext().displayValue;
    var handleStyleProps = useTheme().handleStyleProps;
    var css = handleStyleProps(forwardProps, { themeKey: "sliderHandle" }).css;
    return (jsx(SliderHandle$1, __assign({ "data-display-value": displayValue, "data-placeholder": valueLabel }, (label && { "aria-label": label }), (labelledBy && { "aria-labelledby": labelledBy }), { css: css }, forwardProps, { children: children })));
};

export { SliderHandle };
//# sourceMappingURL=SliderHandle.js.map
